import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { DomHelperService } from 'app/global/dom-helper.service';
import { GlobalService } from 'app/global/global.service';
import { Block } from 'app/interfaces/blocks';
import { Checkboxfield } from 'app/interfaces/checkboxfield';
import { DatepickerField } from 'app/interfaces/datepickerfield';
import { DroplistField } from 'app/interfaces/droplistfields';
import { Field } from 'app/interfaces/fields';
import { MultichoiceField } from 'app/interfaces/multichoicefield';
import { Signaturefield } from 'app/interfaces/signaturefield';
import { Textfield } from 'app/interfaces/textfield';
import { delay, of, Subscription, take } from 'rxjs';
import uuid from 'short-unique-id';
import { Blocks } from '../blocks/blocks';
import { Fields } from '../fields/fields';
import { FieldRenderService } from '../../edit-template/field-render.service';
declare const $;

@Injectable({
    providedIn: 'root'
})
export class ContentTabService {
    private renderer: Renderer2;
    private uuid = new uuid({ length: 6, dictionary: 'number' });
    constructor(
        private globalService: GlobalService,
        public Fields: Fields,
        public Blocks: Blocks,
        private domHelperService: DomHelperService,
        rendererFactory: RendererFactory2,
        private _translocoService:TranslocoService,
        private _fieldRendererService: FieldRenderService
    ) { 
        this.renderer = rendererFactory.createRenderer(null, null);
    }
    private timeOutSubscription: Subscription;
    /**
   * show the field popover based on view type
   * @param element 
   * @param field 
   */
    fieldsPopOver(element, fieldData: Field) {
        let fieldType = '';
        if (fieldData.field == 'text-field') {
            fieldType = 'textFieldSetting';
        } else if (fieldData.field == 'checkbox-field') {
            fieldType = 'checkBoxFieldSetting';
        } else if (fieldData.field == 'droplist-field') {
            fieldType = 'droplistFieldSetting';
        } else if (fieldData.field == 'datepicker-field') {
            fieldType = 'datepickerFieldSetting';
        } else if (fieldData.field == 'signature-field') {
            fieldType = 'signatureFieldSetting';
        } else if (fieldData.field == 'multichoice-field') {
            fieldType = 'multiChoiceFieldSetting';
        }
        const fieldComponent = this.Fields.fieldPopOver({ class: fieldType });
        document.querySelectorAll('.fieldsPopover').forEach((ele: HTMLElement) => {
            ele.remove();
        });
        $('.contentBox-popover-container').remove();
        $('.formBlock-popover-container').remove();
        $('.pageBreak-popover-container').remove();

        this.timeOutSubscription = of(null).
            pipe(
                delay(1),
                take(1)
            ).subscribe(() => {
                $(document.body).append(fieldComponent)
                const top = parseInt($(element).offset().top);
                const left = parseInt($(element).offset().left);
                const width = parseInt($(element).width()) / 2;
                const getPopoverHeight = $('.' + fieldType + '-popover-container').height() + 5
                $('.' + fieldType + '-popover-container').css({ 'top': top - getPopoverHeight, 'left': left + width + 10 }).attr('uuid', $(element).attr('uuid'));
            });
        $(".draggable").find("textarea, input").on('mousedown', function (e) {
            const mdown = new MouseEvent("mousedown", {
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY,
                view: window
            });
            $(this).closest('.draggable')[0].dispatchEvent(mdown);
        }).on('click', function (e) {
            const $draggable = $(this).closest('.draggable');
            if ($draggable.data("preventBehaviour")) {
                e.preventDefault();
                $draggable.data("preventBehaviour", false)
            }
        });
    }

    /**
   * remove any field
   * @param uuid 
   */
    removeField(uuid, blockuuid: string | number = 0) {
        const fieldsPopover = document.querySelector(".fieldsPopover[uuid='" + uuid + "']");
        if (fieldsPopover) {
            fieldsPopover.remove();
        }
        const dragField = document.querySelector(".drag-fields[uuid='" + uuid + "']");
        if (dragField) {
            dragField.remove();
        }
        this.globalService.removeSignature(uuid);
        if(!this.globalService.fields_data[uuid]?.pinned_field) {
            this.globalService.deleteField(uuid);
        } else {
            this._fieldRendererService.unmarkRendered(uuid);
        }
        if (blockuuid) {
            this.globalService.unsetBlockField(uuid, blockuuid);
        }
        const element: HTMLElement = document.querySelector('.closeMenu') as HTMLElement;
        element?.click();
    }

    /**
       * add the field in editor
       * @param top 
       * @param left 
       * @param field_type 
       * @param opts 
       */
    addField(top, left, field_type, opts: { pdfblock: HTMLElement }, fieldType: string) {
        let field = {};
        const uuid = this.uuid();
        const options = [{ name: this._translocoService.translate("Content drop list option menu - (Template/Document - section) - Option") + " 1", id: this.uuid(), value: this._translocoService.translate("Content drop list option menu - (Template/Document - section) - Option") + " 1", meta_data_id: 0 }, { name: this._translocoService.translate("Content drop list option menu - (Template/Document - section) - Option") + " 2", id: this.uuid(), value: this._translocoService.translate("Content drop list option menu - (Template/Document - section) - Option") + " 2", meta_data_id: 0 }];
        const fieldSettings = { top: top, left: left, uuid: uuid, pdfblock: opts.pdfblock, options, type: fieldType };
        this.Fields.addPdfField(fieldSettings, (uuid) => {
            if (field_type == 'text-field') {
                field = Textfield.tag({ type_of: 'field', uuid: uuid, field_info: 'custom_field', field_required: 1 });
            } else if (field_type == 'checkbox-field') {
                field = Checkboxfield.tag({ type_of: 'field', uuid: uuid, field_info: 'custom_field', field_required: 1 });
            } else if (field_type == 'datepicker-field') {
                field = DatepickerField.tag({ type_of: 'field', uuid: uuid, field_info: 'custom_field', field_required: 1 });
            } else if (field_type == 'signature-field') {
                field = Signaturefield.tag({ select_type_text: "Signature", value: this.globalService.user_settings.signature, type_of: 'field', uuid: uuid, field_info: 'custom_field', field_required: 1 });
            } else if (field_type == 'droplist-field') {
                field = DroplistField.tag({ type_of: 'field', uuid: uuid, field_info: 'custom_field', field_required: 1 });
            } else if (field_type == 'multichoice-field') {
                field = MultichoiceField.tag({ type_of: 'field', uuid: uuid, field_info: 'custom_field', field_required: 1, options: options });
            }
            if (opts?.pdfblock) {
                const pdfBlock = (opts.pdfblock as HTMLElement);
                this.renderer.setAttribute(document.querySelector('.drag-fields[uuid="' + uuid + '"]'), 'pdfblock', '1');
                const contentUuid = pdfBlock.getAttribute('editor-uuid');
                const contentBlock: Block = this.globalService.fields_data['blocks'][contentUuid];
                contentBlock.fields.push(uuid);
            }
            this.globalService.fields_data[uuid] = field;

            this.globalService.initializeDragOnEditorFields(field_type, $('.drag-fields[uuid="' + uuid + '"]'));
            if (field_type == 'datepicker-field') {
                this.renderer.setAttribute(document.querySelector('[uuid="' + uuid + '"] input'), 'readonly', 'true');
                this.domHelperService.initializeEventListener('.datepicker-field.content-draggable-field', 'mousedown', 'openDatepicker');
            } else if (field_type == "signature-field") {
                this.domHelperService.initializeEventListener('.generate-signature', 'click', 'generateSignatureForSender');
            } else if (field_type == "checkbox-field") {
                this.domHelperService.initializeEventListener(document.querySelectorAll('.checkbox-field-box'), 'click', 'toggleCheckBox', { role_id: 0 });
            } else if (field_type == "multichoice-field") {
                this.domHelperService.initializeEventListener(document.querySelectorAll('.multiChoice-box'), 'click', 'multiChoiceAction', { role_id: 0 });
            }
            this.domHelperService.initializeEventListener(document.querySelectorAll('.droplist-menu'), 'click', 'openDropListMenu', { role_id: 0 });
            this.domHelperService.initializeEventListener(document.querySelectorAll('.search-drop-value'), 'keyup', 'searchDropDownLabelOnKeyUp', { role_id: 0 });
        });
    }

}